export default __webpack_public_path__ + "static/media/yellow_5.fa802dd1.png";